import { render } from "./all-purchases.vue?vue&type=template&id=f56a0d54&scoped=true"
import script from "./all-purchases.vue?vue&type=script&lang=js"
export * from "./all-purchases.vue?vue&type=script&lang=js"

import "./all-purchases.vue?vue&type=style&index=0&id=f56a0d54&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56a0d54"]])

export default __exports__